import React from 'react';
import API from "../utils/API";
import { cleanAuth } from "../utils/Auth";
import { connect } from 'react-redux';
import { withRouter, Link as RouterLink } from "react-router-dom";
import Avatar from '@material-ui/core/Avatar';
import Button from '@material-ui/core/Button';
import CssBaseline from '@material-ui/core/CssBaseline';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';
import { withStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import { withTranslation } from 'react-i18next';
import Link from '@material-ui/core/Link';

const styles = theme => ({
    paper: {
      paddingTop: theme.spacing(8),
      paddingBottom: theme.spacing(8),
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2),
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      backdropFilter: "blur(10px)",
      backgroundColor: 'rgba(255,255,255,0.3)',
      borderRadius: "4px"
    },
    avatar: {
      margin: theme.spacing(1),
      backgroundColor: theme.palette.secondary.main,
    },
    form: {
      width: '100%', // Fix IE 11 issue.
      marginTop: theme.spacing(1),
    },
    submit: {
      margin: theme.spacing(3, 0, 2),
    },
    background: {
        width: "100vw",
        height: "100vh",
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        overflow: "auto",
        padding: "40px 0"
    }
});

function mapStateToProps(state) {
  return {
    loggedIn: state.loggedIn
  };
}

class ResetPassword extends React.Component {
    
  constructor(props) {
      super(props);
      
      const query = new URLSearchParams(this.props.location.search);
      const token = query.get('token') || '';
      const username = query.get('username') || '';
      const email = query.get('email') || '';

      this.state = {
        username: username,
        email: email,
        token: token,
        password: '',
        repeatPassword: '',
        error: 'ok',
        mensaje_error: '',
        success: false,
        id_image: (Math.floor(Math.random() * 6) + 1)
      };
      
      this.handleInputChange = this.handleInputChange.bind(this);
      this.resetPassword = this.resetPassword.bind(this);
      this.keyPress = this.keyPress.bind(this);
      cleanAuth();
      this.props.dispatch({ type: "LOGOUT" });
  }

  async resetPassword(e) {
    const { t } = this.props;
    e.preventDefault();

    if (!this.state.token || !this.state.username || !this.state.email) {
      this.setState({
        error: "ko",
        mensaje_error: t("El enlace de recuperación no es válido o está incompleto.")
      });
      return;
    }

    if (this.state.password.length < 6) {
      this.setState({
        error: "ko",
        mensaje_error: t("La contraseña debe tener al menos 6 caracteres.")
      });
      return;
    }

    if (this.state.password !== this.state.repeatPassword) {
      this.setState({
        error: "ko",
        mensaje_error: t("Las contraseñas no coinciden.")
      });
      return;
    }

    const payload = {
      username: this.state.username,
      email: this.state.email,
      token: this.state.token,
      new_password: this.state.password
    };

    try {
      let rep = await API.post('/user/reset-password', payload);
      if (rep.data.status === "ok") {
        this.setState({
          success: true,
          error: "ok",
          mensaje_error: t("Contraseña actualizada correctamente.")
        });
      } else {
        this.setState({
          error: "ko",
          mensaje_error: rep.data.message
        });
      }
    } catch (err) {
      this.setState({
        error: "ko",
        mensaje_error: t("Error de conexión")
      });
      console.log(err.message);
    }
  }

  keyPress(e) {
    if (e.keyCode === 13) {
      this.resetPassword(e);
    }
  }

  handleInputChange(event) {
    const target = event.target;
    const value = target.value;
    const name = target.name;

    this.setState({
      [name]: value
    });
  }

  render() {
    const classes = this.props.classes;
    const { t } = this.props;

    return (
      <div className={classes.background} style={{backgroundImage: "url('" + process.env.PUBLIC_URL + "/images/backgrounds/" + this.state.id_image + ".jpeg')"}}>
        <Container component="main" maxWidth="xs">
          <CssBaseline />
          <div className={classes.paper}>
            <Avatar className={classes.avatar}>
              {/* Reset Password Icon */}
            </Avatar>
            <Typography component="h1" variant="h5">
              {t('Restablecer contraseña')}
            </Typography>

            {this.state.success ? (
              <div style={{ width: '100%', marginTop: '20px', textAlign: 'center' }}>
                <p style={{ color: "green", fontWeight: "bold" }}>{this.state.mensaje_error}</p>
                <Button
                  type="button"
                  fullWidth
                  variant="contained"
                  color="primary"
                  className={classes.submit}
                  onClick={() => this.props.history.push("/login")}
                >
                  {t("Volver al inicio de sesión")}
                </Button>
              </div>
            ) : (
              <form className={classes.form} noValidate>
                <TextField
                  variant="outlined"
                  margin="normal"
                  fullWidth
                  id="username"
                  label={t("Nombre de usuario")}
                  name="username"
                  value={this.state.username}
                  disabled
                />
                <TextField
                  variant="outlined"
                  margin="normal"
                  fullWidth
                  id="email"
                  label={t("Correo electrónico")}
                  name="email"
                  value={this.state.email}
                  disabled
                />
                <TextField
                  variant="outlined"
                  margin="normal"
                  required
                  error={this.state.error === "ko" && this.state.mensaje_error.includes(t("contraseña"))}
                  fullWidth
                  name="password"
                  label={t("Nueva contraseña")}
                  type="password"
                  id="password"
                  onChange={this.handleInputChange}
                  onKeyDown={this.keyPress}
                  autoFocus
                />
                <TextField
                  variant="outlined"
                  margin="normal"
                  required
                  error={this.state.error === "ko" && this.state.mensaje_error.includes(t("coinciden"))}
                  fullWidth
                  name="repeatPassword"
                  label={t("Repite nueva contraseña")}
                  type="password"
                  id="repeatPassword"
                  onChange={this.handleInputChange}
                  onKeyDown={this.keyPress}
                />
                <Button
                  type="button"
                  fullWidth
                  variant="contained"
                  color="primary"
                  className={classes.submit}
                  onClick={this.resetPassword}
                >
                  {t("Restablecer")}
                </Button>
                <p style={{color:"#f00"}}>{this.state.mensaje_error}</p>
                
                <div style={{ textAlign: 'center', marginTop: '10px' }}>
                  <Link component={RouterLink} to="/login" variant="body2">
                    {t("Volver al inicio de sesión")}
                  </Link>
                </div>
              </form>
            )}
          </div>
        </Container>
      </div>
    );
  }
}

export default withTranslation()(withRouter(withStyles(styles)(connect(mapStateToProps)(ResetPassword))));
